import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { authVerifiedRoute } from 'root/routeTree';

export const merchantSelectionRoute = createRoute({
  getParentRoute: () => authVerifiedRoute,
  path: 'merchant-selection',
  component: lazyRouteComponent(() => import('./MerchantSelectionView')),
});
